import React from "react";
import { Leaf, ShieldCheck, Handshake, MessageSquare } from "lucide-react";
import PageHero from "@/components/PageHero";
import { IMG } from "@/lib/siteData";
import { useLang } from "@/context/LangContext";

export default function EngagementPage() {
    const { t } = useLang();
    const items = [
        { icon: ShieldCheck, title: t("Fiabilité", "Reliability"), text: t("Des partenaires sélectionnés et un suivi rigoureux de chaque expédition, de l'enlèvement à la livraison.", "Selected partners and rigorous tracking of every shipment, from collection to delivery.") },
        { icon: MessageSquare, title: t("Transparence", "Transparency"), text: t("Une information claire sur les délais, les coûts et le statut de vos envois.", "Clear information on lead times, costs and the status of your shipments.") },
        { icon: Leaf, title: t("Transport plus durable", "More sustainable transport"), text: t("Nous privilégions les solutions multimodales et l'optimisation des chargements pour réduire l'impact environnemental.", "We favour multimodal solutions and load optimisation to reduce environmental impact.") },
        { icon: Handshake, title: t("Relation de confiance", "A relationship of trust"), text: t("Un interlocuteur à votre écoute et des solutions construites avec vous, sur le long terme.", "A contact who listens and solutions built with you, for the long term.") },
    ];
    return (
        <>
            <PageHero testid="engagement-hero" eyebrow={t("Notre engagement", "Our commitment")} img={IMG.world} title={t("Des engagements concrets, à chaque expédition", "Concrete commitments, on every shipment")} />
            <section className="max-w-7xl mx-auto px-5 lg:px-8 py-16 grid sm:grid-cols-2 gap-6">
                {items.map((it, i) => (
                    <div key={it.title} data-testid={`engagement-item-${i}`} className="flex gap-5 border border-slate-200 rounded-md p-6 hover:shadow-lg transition-shadow">
                        <div className="w-14 h-14 rounded bg-orange-50 flex items-center justify-center shrink-0"><it.icon size={28} className="text-[#f26b1d]" strokeWidth={1.5} /></div>
                        <div>
                            <h2 className="font-semibold text-lg">{it.title}</h2>
                            <p className="text-sm text-slate-600 mt-2 leading-relaxed">{it.text}</p>
                        </div>
                    </div>
                ))}
            </section>
        </>
    );
}
